import React, { ReactNode } from 'react';
import {
  Modal as TonicModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Flex,
} from '@tonic-ui/react';

export interface ModalProps {
  body: ReactNode;
  header: ReactNode;
  footer?: ReactNode;
  /** For testing and telemetry. */
  id: string;
  size?: string;
  closeOnEsc?: boolean;
  ensureFocus?: boolean;
  autoFocus?: boolean;
  isClosable?: boolean;
  closeOnOutsideClick?: boolean;
  isOpen: boolean;
  onClose: () => void;
}

const Modal = ({
  body,
  header,
  footer,
  id,
  size = 'md',
  closeOnEsc = true,
  ensureFocus = true,
  autoFocus = true,
  isClosable = true,
  closeOnOutsideClick = true,
  isOpen,
  onClose,
  ...rest
}: ModalProps): JSX.Element => {
  return (
    <TonicModal
      data-id={`${id}-modal`}
      data-telemetry-id={`${id}-modal`}
      autoFocus={autoFocus}
      closeOnEsc={closeOnEsc}
      closeOnOutsideClick={closeOnOutsideClick}
      ensureFocus={ensureFocus}
      isClosable={isClosable}
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      {...rest}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Flex justify="flex-start" align="center" data-id={`${id}-modal-title`}>
            {header}
          </Flex>
        </ModalHeader>
        <ModalBody>{body}</ModalBody>
        {footer && <ModalFooter>{footer}</ModalFooter>}
      </ModalContent>
    </TonicModal>
  );
};

Modal.displayName = 'Modal';
export default Modal;
